var map = {
	"./ca.json": "a4e4",
	"./de.json": "6ce2",
	"./en-GB.json": "282d",
	"./es.json": "a306",
	"./eu.json": "3fdb",
	"./fr.json": "f693",
	"./gl.json": "a2bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";